import env from 'config/build'

export const { CONTENTFUL_PREVIEW_DOMAIN, CONTENTFUL_PROD_DOMAIN } =
  env.domains || {}
export const NODE_ENV = env.nodeEnv
